import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useParams } from 'react-router-dom';
import RedemptionEditor from './RedemptionEditor';
import SaveRedemptionBenefit from './SaveRedemptionBenefit';
const RedemptionBenefitScreen = () => {
    const { benefitId } = useParams();
    if (!benefitId)
        return null;
    return (_jsxs("div", { className: "flex flex-wrap justify-center font-sans", children: [_jsx(RedemptionEditor, { id: benefitId }), _jsx("div", { className: "w-full" }), _jsx(SaveRedemptionBenefit, { id: benefitId })] }));
};
export default RedemptionBenefitScreen;
